import type { AuthContextType } from '@context/auth.context';
import type { Conversation } from '@interfaces/conversation';
import { apiRequest, isResponse } from '@services/fetcher';
import type { LoaderFunction } from 'react-router-dom';

import { initConversations, useBoundStore } from '@/newstore';

export const loader = (auth: AuthContextType) =>
  (async ({ request }) => {
    const response = await apiRequest<Conversation[]>(`${import.meta.env.VITE_API_URL}/conversation`, auth, {
      signal: request.signal,
    });

    if (isResponse(response)) {
      return {
        status: response.status,
        statusText: response.statusText,
      } as Response;
    }

    if (response instanceof Error) {
      throw response;
    }

    // return { conversations: response };
    initConversations(response);

    useBoundStore.getState().showLeftColumn();

    return response;
  }) satisfies LoaderFunction;
